import {RootState} from '../reducer/index'
import {_CALL_API} from '../../middleware/api'
import {_API, _CRUD} from './_Action'
import { route } from 'src/conf/routes'

export const getPageJson = (url: string) => (dispatch, getState: () => RootState) => {
    const actions = _API('get_page_json')
    return dispatch({
      [_CALL_API]: {
        types: [actions.REQUEST, actions.SUCCESS, actions.FAILURE],
        route: route.pages.get(url)
      }
    })
}

export const FOOTER = 'footer'
const _FOOTER_CRUD = _CRUD(FOOTER)
export const getFooter = () => (dispatch, getState: () => RootState) => {
    return dispatch({
      [_CALL_API]: {
        types: [_FOOTER_CRUD.GET.REQUEST, _FOOTER_CRUD.GET.SUCCESS, _FOOTER_CRUD.GET.FAILURE],
        route: route.pages.get(FOOTER)
      }
    })
}
  


// WEBPACK FOOTER //
// ./src/core/redux/action/seoAction.ts